import React, { useCallback, useEffect } from 'react'
import { useSpring, animated } from 'react-spring'
import { useVideo } from 'react-use'

import { useApp } from 'store/AppStore'

import { Bottom, EnterButton, Root } from './Landing.styled.js'

import introVideoMp4 from 'assets/videos/intro_video.mp4'
import introVideoWebm from 'assets/videos/intro_video.webm'
import subtitles from 'assets/videos/intro_subtitles.vtt'

import useAnalyticsEventTracker from '../../lib/useAnalyticsEventTracker.jsx';

import ReactGA from "react-ga4";

ReactGA.send({ hitType: "pageview", page: "/Landing", title: "Landing" });





const Landing = ({ entering }) => {

const gaEventTracker = useAnalyticsEventTracker('Landing');


  const { setCurrentView, isPortrait } = useApp()
  const [video, state, controls] = useVideo(
    <video
      //autoPlay
      //playsInline
      muted
      onClick={() => {
        controls.unmute()
      }}
    >
      <source src={introVideoMp4} type="video/mp4" />
      <source src={introVideoWebm} type="video/webm" />
      <track label="English" kind="subtitles" srcLang="en" src={subtitles} default></track>
    </video>
  )

  const [videoSpring, videoApi] = useSpring(() => ({
    opacity: 0,
  }))

  const [bgSpring, bgApi] = useSpring(() => ({
    opacity: 0,
  }))

  const [titleSpring, titleApi] = useSpring(() => ({
    opacity: 0,
    letterSpacing: 50,
    filter: 'blur(16px)',
    immediate: true,
  }))

  const [titleSpringDelay, titleApiDelay] = useSpring(() => ({
    opacity: 0,
    letterSpacing: 5,
    filter: 'blur(16px)',
    delay: 0,
  }))

  const [subtitleSpring, subtitleApi] = useSpring(() => ({
    opacity: 0,
    letterSpacing: 25,
  }))

  const [bottomSpring, bottomApi] = useSpring(() => ({
    y: 200,
    opacity: 0,
  }))

  const enterAnimation = useCallback(() => {
    titleApi.start({
      opacity: 1,
      filter: 'blur(0px)',
      letterSpacing: 1,
      delay: 100,
    })
    titleApiDelay.start({
      opacity: 1,
      filter: 'blur(0px)',
      letterSpacing: 1,
      delay: 1000,
    })
    subtitleApi.start({
      opacity: 1,
      letterSpacing: 4,
      delay: 350,
    })
    bottomApi.start({
      y: 0,
      opacity: 1,
      delay: 700,
    })
    bgApi.start({
      opacity:1,
      delay: 0,
    })
  }, [titleApi, subtitleApi, bottomApi,bgApi])

  const leaveAnimation = useCallback(
    (immediate) => {
      titleApi.start({
        opacity: 0,
        filter: 'blur(16px)',
        letterSpacing: 50,
        immediate: immediate,
        delay: immediate ? 0 : 200,
      })
      titleApiDelay.start({
        opacity: 0,
        filter: 'blur(16px)',
        letterSpacing: 5,
        immediate: immediate,
        delay: immediate ? 0 : 200,
      })
      subtitleApi.start({
        opacity: 0,
        letterSpacing: 25,
        immediate: immediate,
      })
      bottomApi.start({
        y: 200,
        opacity: 0,
        immediate: immediate,
      })
      bgApi.start({
        opacity: 0,
        delay: 400,
      })
      /*
      if (!immediate) {
        bgApi.start({
          opacity: 0,
          delay: 400,
        })
      }
      */
    },
    [titleApi, subtitleApi, bottomApi, bgApi]
  )

  useEffect(() => {
    if (!state.paused) {
      videoApi.start({
        opacity: 1,
      })
      leaveAnimation(true)
      bgApi.start({
        opacity: 1,
      })
    } else {
      videoApi.start({
        opacity: 0,
      })
      enterAnimation()
    }
  }, [state, videoApi, bgApi, enterAnimation, leaveAnimation])

  useEffect(() => {
    if (entering < 100 && state.paused) {
      leaveAnimation(false)
    }
  }, [entering, state, leaveAnimation])

  /*
function logstest(){
  setTimeout(() => {
    console.log("Entering : ",state)
    //logstest()
  }, 20000);
}
logstest()


style={{bgSpring, background:"rgb(10, 66, 93)"}}
*/

  return (
    <Root isPortrait={isPortrait} isMuted={state.muted}>
      <animated.div className="Background" style={{ background:"rgb(10, 66, 93)",...bgSpring}}></animated.div>
      <animated.div className="VideoContainer" style={videoSpring}>
        {video}
        {state.muted && <div className="info">Click on video to unmute</div>}
      </animated.div>
      <animated.div style={subtitleSpring}>over</animated.div>
      <animated.div className="Title" style={titleSpring}>
        30 years
      </animated.div>
      <animated.div style={subtitleSpring}>of innovation</animated.div>
      <Bottom>
      </Bottom>
      <div id="aosexp">
      <animated.div className="Title" style={titleSpring}>
        Touch Experience
      </animated.div>
      <br />
        <animated.div className='contentexp' style={bottomSpring}>
      <animated.div id="enterdiv" style={bottomSpring}>
        <EnterButton id="aostriggerready" onClick={() => {setCurrentView('timeline'); gaEventTracker('Launching')} }>enter experience</EnterButton>
        </animated.div>
        </animated.div>
        <animated.div className="TitleInfo" style={titleSpringDelay}>
        ( USE YOUR FINGER ON SCREEN )
      </animated.div>
        </div>
      <div id="touchexp">
      <animated.div className="Title" style={titleSpring}>
        AOS Experience
      </animated.div>
      <br />
      <animated.div className='contentexp' style={bottomSpring}>
      <animated.div id="enterdiv" style={bottomSpring}>
      <div id="imgqr"></div>
        </animated.div>
        </animated.div>
        <animated.div className="TitleInfo" style={titleSpringDelay}>
        ( USE YOUR PHONE AS A REMOTE )
      </animated.div>
        </div>
    </Root>
  )
}

export default Landing
